import { render, staticRenderFns } from "./tabCargo.vue?vue&type=template&id=b06bdf3a"
import script from "./tabCargo.vue?vue&type=script&lang=js"
export * from "./tabCargo.vue?vue&type=script&lang=js"
import style0 from "./tabCargo.vue?vue&type=style&index=0&id=b06bdf3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports